import MenuItem from '../../../core/menu/item.gjs';

const METADATA = {
  component: 'Spds::Action::Button::Dropdown::MenuItem',
  description: 'Menu item component for dropdown buttons',
  name: 'Dropdown Menu Item',
};

export default class SpdsActionButtonDropdownMenuItem extends MenuItem {
  static metadata = MenuItem.setMetadata(METADATA);
  variantClass = 'spds-action-button-dropdown-menu-item';

  onClick = (...args) => {
    super.onClick(...args);

    this.args.toggleOpenState();
  };
}

export const ACTION_BUTTON_DROPDOWN_MENU_ITEM_METADATA = SpdsActionButtonDropdownMenuItem.metadata;
